export default __webpack_public_path__ + "static/media/reddit-text.3dac2cb0.png";